import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const PolitiqueConfidentialitePage = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6 lg:px-12" data-testid="politique-confidentialite-page">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white mb-8 transition-colors" data-testid="politique-back-link">
          <ArrowLeft size={18} />
          Retour
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-4xl font-bold text-white mb-12" data-testid="politique-title">Politique de confidentialit{"é"}</h1>

          <div className="space-y-10 text-white/70 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Protection de la vie priv{"é"}e et des donn{"é"}es personnelles</h2>
              <p>
                Le site collecte les informations personnelles fournies par les utilisateurs {"à"} l{"'"}occasion de leur visite sur le site.
              </p>
              <p className="mt-4">Cette collecte permet :</p>
              <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
                <li>L{"'"}{"é"}tablissement de statistiques g{"é"}n{"é"}rales sur le trafic sur le site</li>
                <li>L{"'"}envoi vers les adresses mail fournies par les utilisateurs de r{"é"}ponses, d{"'"}informations diverses ou annonces provenant de l{"'"}{"é"}diteur</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Conformit{"é"} l{"é"}gale</h2>
              <p>
                La collecte et le traitement des informations personnelles sur Internet doivent se faire dans le respect des droits 
                fondamentaux des personnes. Par cons{"é"}quent, l{"'"}{"é"}diteur s{"'"}engage {"à"} une politique de traitement en conformit{"é"} avec 
                la loi n{"°"}2004-575 du 21 juin 2004 pour la confiance dans l{"'"}{"é"}conomie num{"é"}rique.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Droits des utilisateurs</h2>
              <p>
                Tout utilisateur du site dispose d{"'"}un droit d{"'"}acc{"è"}s, modification, de rectification ou de suppression aux donn{"é"}es 
                personnelles le concernant. Il peut exercer ces droits en contactant l{"'"}{"é"}diteur aux coordonn{"é"}es suivantes :
              </p>
              <ul className="mt-4 space-y-2">
                <li><strong className="text-white/90">WEBISULA</strong></li>
                <li><strong className="text-white/90">Si{"è"}ge social :</strong> Route des Sanguinaires, Ajaccio</li>
                <li><strong className="text-white/90">Email :</strong> webisula@gmail.com</li>
              </ul>
              <p className="mt-4">
                Pour faciliter l{"'"}exercice de ces droits, les utilisateurs du site peuvent se d{"é"}sinscrire en cliquant sur les liens 
                hypertextes de d{"é"}sinscription pr{"é"}sents sur les mails adress{"é"}s.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Cookies</h2>
              <p>
                Les ordinateurs se connectant aux serveurs du site re{"ç"}oivent sur leur disque dur un ou plusieurs fichiers au format texte 
                tr{"è"}s l{"é"}gers appel{"é"}s commun{"é"}ment {'"'}Cookies{'"'}. Les cookies enregistrent des informations relatives {"à"} la navigation sur le site 
                effectu{"é"}e {"à"} partir de l{"'"}ordinateur sur lequel est stock{"é"} le cookie (les pages consult{"é"}es, la date et l{"'"}heure de la 
                consultation, etc.). Ils permettent d{"'"}identifier les visites successives faites {"à"} partir d{"'"}un m{"ê"}me ordinateur.
              </p>
              <p className="mt-4">
                Les personnes connect{"é"}es au site ont la libert{"é"} de s{"'"}opposer {"à"} l{"'"}enregistrement de cookies. Pour ce faire, elles peuvent 
                employer les fonctionnalit{"é"}s correspondantes sur leur navigateur. Cependant, l{"'"}{"é"}diteur attire l{"'"}attention des utilisateurs que, 
                dans un tel cas, l{"'"}acc{"è"}s {"à"} certains services du site peut se r{"é"}v{"é"}ler alt{"é"}r{"é"}, voire impossible.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">S{"é"}curit{"é"} des {"é"}changes</h2>
              <p>
                L{"'"}{"é"}diteur s{"'"}engage {"à"} prendre toutes les mesures juridiques et techniques pour s{"é"}curiser les {"é"}changes. 
                {"À"} ce titre, l{"'"}{"é"}diteur s{"'"}engage {"à"} une obligation de moyen pour bloquer les d{"é"}tournements de donn{"é"}es, et {"à"} 
                respecter les r{"é"}glementations applicables.
              </p>
              <p className="mt-4">
                N{"é"}anmoins, les utilisateurs du site connaissent les particularit{"é"}s techniques du r{"é"}seau Internet et les risques aff{"é"}rents. 
                Par cons{"é"}quent, l{"'"}{"é"}diteur ne peut garantir {"à"} ses utilisateurs que les donn{"é"}es {"é"}chang{"é"}es via les services propos{"é"}s par le 
                site ne soient pas r{"é"}colt{"é"}es de fa{"ç"}on frauduleuse par des tiers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Responsable du traitement</h2>
              <ul className="space-y-2">
                <li><strong className="text-white/90">Raison sociale :</strong> WEBISULA</li>
                <li></li>
                <li><strong className="text-white/90">Si{"è"}ge social :</strong> Route des Sanguinaires, Ajaccio</li>
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialitePage;
